import z from 'zod';

import { ForeclosureId, ReportableEventId } from '../BrandedIds';
import { zodJSInstantDate, zodJSPlainDate } from '../dates/BrandedDate';
import { OptionalPhoneNumber } from '../Phone';

export const ForeclosureStatus = z.enum(['active', 'onHold', 'cancelled', 'completed', 'archived']);
export type ForeclosureStatus = z.infer<typeof ForeclosureStatus>;

export const ForeclosureOutcome = z.enum([
  'payoff',
  'reinstatement',
  'modification',
  'liquidation',
  'reo',
  'bankruptcy',
  'other',
]);
export type ForeclosureOutcome = z.infer<typeof ForeclosureOutcome>;

export const ForeclosureStateType = z.enum(['judicial', 'nonJudicial']);
export type ForeclosureStateType = z.infer<typeof ForeclosureStateType>;

export const Foreclosure = z.object({
  id: ForeclosureId,
  status: ForeclosureStatus,
  statusHistory: z
    .object({
      status: ForeclosureStatus,
      changedAt: zodJSInstantDate,
    })
    .array(),
  referralDate: zodJSPlainDate,
  firstLegalActionDate: zodJSPlainDate.optional(),
  lawFirm: z.string().optional(),
  attorneyName: z.string().optional(),
  attorneyPhone: OptionalPhoneNumber,
  stateType: ForeclosureStateType.optional(),
  createdAt: zodJSInstantDate,
  updatedAt: zodJSInstantDate,
  archivedAt: zodJSInstantDate.optional(),

  /** date loan status changed out of foreclosure */
  endDate: zodJSPlainDate.optional(),

  /** outcome of a cancelled or completed foreclosure */
  endOutcome: ForeclosureOutcome.optional(),

  /** true if foreclosure was completed with a deficiency still owed to the lender */
  endDeficiencyOwedFlag: z.boolean().optional(),

  reportableEventIds: z.array(ReportableEventId),
});
export type Foreclosure = z.infer<typeof Foreclosure>;
